import type { CmsApiFlashCardQuizBlockData } from '#/modules/cms/api/types/blocks/CmsApiFlashCardQuizBlock';

import { CmsFlashCardQuizBlockCard } from './CmsFlashCardQuizBlockCard';

type Props = {
  blockIndex: number;
  data: CmsApiFlashCardQuizBlockData;
};

export function CmsFlashCardQuizBlock({ blockIndex, data: { cards } }: Props) {
  return (
    <div>
      {cards.map((card, index) => (
        <CmsFlashCardQuizBlockCard
          blockIndex={blockIndex} // oxlint-disable-next-line react/no-array-index-key
          key={index}
          card={card}
          index={index}
        />
      ))}
    </div>
  );
}
